import React, { useEffect, useState } from "react";
import { getScadenze, setScadenze } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Save, AlertTriangle, AlertCircle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ScadenzeSettings() {
  const [cfg, setCfg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { getScadenze().then((r) => setCfg(r.config)).finally(() => setLoading(false)); }, []);

  const save = async () => {
    try {
      await setScadenze({
        gialla_giorni: Number(cfg.gialla_giorni),
        rossa_giorni: Number(cfg.rossa_giorni),
      });
      toast.success("Soglie aggiornate");
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };

  if (loading || !cfg) return <div className="p-4 text-slate-500">Caricamento…</div>;

  return (
    <div className="space-y-4" data-testid="scadenze-settings-page">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900">Soglie scadenze</h1>
        <p className="text-slate-500 text-sm mt-1">Due soglie configurabili in giorni → 4 livelli badge</p>
      </div>

      <Card className="p-5 bg-white border border-slate-200 shadow-sm space-y-4">
        <Row
          color="#C62828" outline icon={<AlertTriangle size={20} />}
          title="Scaduto"
          desc="Sotto 0 giorni · rosso pieno"
          fixed
        />
        <Row
          color="#C62828" icon={<AlertCircle size={20} />}
          title="Allerta rossa"
          desc="Sotto soglia rossa · rosso bordato"
          unit="giorni"
          value={cfg.rossa_giorni}
          onChange={(v) => setCfg({ ...cfg, rossa_giorni: v })}
          testid="rossa-giorni"
        />
        <Row
          color="#F57C00" icon={<AlertCircle size={20} />}
          title="Allerta gialla"
          desc={`Tra ${cfg.rossa_giorni} e`}
          unit="giorni"
          value={cfg.gialla_giorni}
          onChange={(v) => setCfg({ ...cfg, gialla_giorni: v })}
          testid="gialla-giorni"
        />
        <Row
          color="#1B5E20" icon={<CheckCircle2 size={20} />}
          title="OK"
          desc={`Oltre ${cfg.gialla_giorni} giorni · nessun badge`}
          fixed
        />
      </Card>

      <Button onClick={save} className="w-full h-12 bg-[#1B5E20] hover:bg-[#144818] text-white" data-testid="save-scadenze-btn">
        <Save size={16} className="mr-2" /> Salva soglie
      </Button>
    </div>
  );
}

function Row({ icon, title, desc, color, value, onChange, testid, fixed, unit, outline }) {
  return (
    <div className="flex items-center gap-3">
      <div className={`h-10 w-10 rounded-lg flex items-center justify-center shrink-0 ${outline ? "border-2" : "text-white"}`} style={outline ? { borderColor: color, color } : { backgroundColor: color }}>{icon}</div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>{title}</div>
        <div className="text-xs text-slate-500">{desc}{!fixed && <span className="font-bold text-slate-700"> {value} {unit}</span>}</div>
      </div>
      {!fixed && (
        <div className="w-24">
          <Label className="text-[10px]">Fine (gg)</Label>
          <Input type="number" min={0} value={value} onChange={(e) => onChange(Number(e.target.value))} data-testid={testid} />
        </div>
      )}
    </div>
  );
}
